const teethSides = ["front", "left side", "right side", "lower", "upper", "face"]

export default teethSides